import React, { useRef, useState, useEffect } from "react";
import { Button, Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import Header from "../../../../components/headers/Header";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import * as Helper from "../../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/agent/management/EditRedux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useForm } from "react-hook-form";

import { NavigationService, NavigateActionTypes } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import "antd/dist/antd.css";

const uid = UIDs.screens.admin.agent.management.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.SAVE_AGENT_ASYNC]: { done: this._handleSaveAgentAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);

        this._handleChangeValue = this._handleChangeValue.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.getAllCountryCodeAsync();
    }

    render() {
        const { agentInfo, countryCodeList } = this.props.localState;
        return (
            <>
                {!agentInfo || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                    ? <LoadingIndicator />
                    : <EditForm
                        {...this.props} 
                        agentInfo={agentInfo}
                        countryCodeList={countryCodeList}
                        onSave={this._handleSaveInfo} 
                        onBack={this._handleBack}
                        onChangeValue={this._handleChangeValue}
                        isDisabled={this.isActionExecuting(ActionTypes.SAVE_AGENT_ASYNC)}
                    />
                }
            </>
        );
    }

    _handleSaveInfo = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        if (!data.countryCode || data.countryCode === "") data.countryCode = "86-CHN";
                        let codes = data.countryCode.split("-");
                        let newPhone = { phone: data.phone, isoCode: codes[0], countryCode: codes[1] };
                        let referralPrize = parseInt(data.referralPrize);

                        data = { ...data, phone: newPhone, referralPrize }
                        this.props.saveAgentAsync(data);
                    },
                },
                {
                    label: this.props.t("no"),
                },
            ],
        });
    };

    _handleBack = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };

    _handleChangeValue = (e) => {
        const { name, value } = e.target;
        var item = {};
        switch(name){
            case "email":
                item = {email: value}
                break;
            case "organization":
                item = {organization: value}
                break;
            case "isTeacher":
                item = {isTeacher: value ? true : false, organization:""}
                break;
        }
        let newVO = {
            ...this.props.localState.agentInfo,
            ...item,
        }
        this.props.updateValues(newVO);

        if(name === "email" && !Helper.isNullOrEmpty(value)){
            this.props.getPartnerByEmailAsync(value);
        }else if(name === "email" && Helper.isNullOrEmpty(value)){
            newVO = {
                ...this.props.localState.agentInfo,
                isTeacher: false,
                organization: "",
                referrerName: "",
                referrerCode: "",
            }
            this.props.updateValues(newVO);
        }
    };

    _handleSaveAgentAsyncDone = () => {
        const { referralCodeAsAgent, sendPwd, referralCodeAsTeacher } = this.props.localState;
        NavigationService.navigateToPage(this, `/admin/agent/management/code`, { referralCodeAsAgent, sendPwd, referralCodeAsTeacher });
    };

}

function EditForm(props) {
    const countries = Helper.getCountries();
    const { firstName, phone, email, wechat, organization, isTeacher, nationality, referrerCode, referrerName, subagentEnabled, referralPrize = 10 } = props.agentInfo;
    const { register, handleSubmit, errors, clearError } = useForm();
    const submitRef = useRef();
    const [state_isTeacher, setstate_isTeacher] = useState(false);
    useEffect(() => {
        setstate_isTeacher(isTeacher);
    }, [isTeacher]);

    let codes = [];
    codes = phone ? phone.split("-") : [];
    let countryCode = codes.length > 1 && codes[0] && codes[1] ? (codes[0] + "-" + codes[1]) : "86-CHN";

    const setTeacher = (value) => {
        if (value === "false") {
            setstate_isTeacher(false);
        } else {
            setstate_isTeacher(true);
        }
    }

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <Row>
                        <Col>
                            <Card className="shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">{props.t("add")}</h3>
                                        </Col>
                                        <Col className="text-right" xs="4">
                                            <Button color="primary" disabled={props.isDisabled} onClick={() => submitRef.current.click()} size="sm">
                                                {props.t("activateNow")}
                                            </Button>
                                            <Button color="default" disabled={props.isDisabled} onClick={() => props.onBack()} size="sm">
                                                {props.t("back")}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("name")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="firstName"
                                                        defaultValue={firstName}
                                                        type="text"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            validate: {
                                                                message: value => {
                                                                    if (value.replace(/\s/g, "").length === 0) {
                                                                        return props.t("nameSpace");
                                                                    }
                                                                    if (value.length > 20) {
                                                                        return props.t("invalidLengthH", { name: props.t("name"), max: 20 });
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })}                                                        
                                                        maxLength={100}
                                                    />
                                                    {errors.firstName && <span className="text-danger">{errors.firstName.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("nationality")}</label>
                                                    <select
                                                        className="form-control-alternative form-control"
                                                        name="nationality"                                                             
                                                        defaultValue={nationality}
                                                        ref={register({ 
                                                            required: props.t("fieldIsRequired") 
                                                        })}>
                                                            <option value="">{props.t("selectACountry")}</option>
                                                            {Object.keys(countries).map(key => {
                                                                    if(key!=="TW" && key!=="HK" && key!=="MO"){
                                                                        return <option selected={nationality===key} value={key}>{countries[key]}</option>
                                                                    }
                                                                }
                                                            )}
                                                    </select>
                                                    {errors.nationality && <span className="text-danger">{errors.nationality.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("phone")}</label>
                                                    <div>
                                                        <div style={{float:"left", width:"40%"}}>
                                                            <select
                                                                name="countryCode" 
                                                                className="form-control-alternative form-control" 
                                                                ref={register({ required: props.t("fieldIsRequired") })} 
                                                                defaultValue={countryCode}
                                                                >
                                                                {props.countryCodeList != null && props.countryCodeList.length >0 ? props.countryCodeList.map((item, index) =>{
                                                                        if(item.countryCode!=="TW" && item.countryCode!=="HK" && item.countryCode!=="MO"){
                                                                            return <option key={index} value={item.isoCode+"-"+item.countryCode}>{Helper.getCountryName(item.countryCode)}+({item.isoCode})</option>
                                                                        }
                                                                    })
                                                                : null}
                                                            </select>
                                                            {errors.countryCode && <span className="text-danger">{errors.countryCode.message}</span>}
                                                        </div>
                                                        <div style={{float:"left", width:"56%", marginLeft: "3%"}}>
                                                            <input
                                                                className="form-control-alternative form-control"
                                                                name="phone"
                                                                defaultValue={""}
                                                                type="text"
                                                                ref={register({
                                                                    required: props.t("fieldIsRequired"),
                                                                    pattern: {
                                                                        value: /^[0-9-]{7,}$/,
                                                                        message: props.t("invalidPhone"),
                                                                    },
                                                                    validate: {
                                                                        message: value => {
                                                                            if (value.length > 20) {
                                                                                return props.t("invalidLength", { name: props.t("phone"), max: 20 });
                                                                            }else if(value.indexOf("--")!=-1){
                                                                                return props.t("invalidPhone");
                                                                            }else if(value.charAt(value.length -1) === "-"){
                                                                                return props.t("invalidPhone");
                                                                            }else if(value.charAt(0) === "-"){
                                                                                return props.t("invalidPhone");
                                                                            }
                                                                            return clearError();
                                                                        }
                                                                    }
                                                                })}
                                                            />
                                                            {errors.phone && <span className="text-danger">{errors.phone.message}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("email")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="email"
                                                        defaultValue={email}
                                                        type="email"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                                message: props.t("invalidEmailAddress"),
                                                            },
                                                            validate: {
                                                                message: value => {
                                                                    if (value.length > 50) {
                                                                        return props.t("invalidLength", { name: props.t("email"), max: 50 });
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })}                                                        
                                                        maxLength={100}
                                                        onBlur={props.onChangeValue}
                                                    />
                                                    {errors.email && <span className="text-danger">{errors.email.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("subAgent")}</label>
                                                    <select
                                                        className="form-control-alternative form-control"
                                                        name="subagentEnabled"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired")
                                                        })}>
                                                            <option value={false} selected={subagentEnabled===false}>{props.t("n")}</option>
                                                            <option value={true} selected={subagentEnabled===true}>{props.t("y")}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("wechat")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="wechat"
                                                        defaultValue={wechat}
                                                        type="text"
                                                        ref={register}                                                        
                                                        maxLength={100}
                                                    />
                                                    {errors.wechat && <span className="text-danger">{errors.wechat.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <input hidden name="isTeacher" type="text" value={state_isTeacher} ref={register} />
                                            {state_isTeacher && <input hidden name="organization" type="text" value={organization} ref={register} />}
                                            {/*注：开通代理的时候，不开通老师了,设置了上面的是否是老师隐藏输入框
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("isTeacher")}</label>
                                                    <select
                                                        disabled = {isTeacher || (referrerCode && referrerName)}
                                                        className="form-control-alternative form-control"
                                                        name="isTeacher"
                                                        onChange={(e) => { setTeacher(e.target.value); props.onChangeValue(e) }}
                                                        ref={register({ 
                                                            required: props.t("fieldIsRequired") 
                                                        })}>
                                                            <option value={false} selected={state_isTeacher===false}>{props.t("n")}</option>
                                                            <option value={true} selected={state_isTeacher===true}>{props.t("y")}</option>
                                                    </select>
                                                    {errors.isTeacher && <span className="text-danger">{errors.isTeacher.message}</span>}
                                                </div>
                                            </div>
                                            {state_isTeacher && <div className="col-lg-4">

                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("organization")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="organization"
                                                        defaultValue={organization}
                                                        type="text"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            validate: {
                                                                message: value => {
                                                                    if (value.length > 50) {
                                                                        return props.t("invalidLengthH", { name: props.t("organization"), max: 50 });
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })}
                                                        maxLength={100}
                                                        onChange={(e) => { props.onChangeValue(e) }}
                                                        disabled = {referrerCode && referrerName}
                                                    />
                                                    {errors.organization && <span className="text-danger">{errors.organization.message}</span>}
                                                </div>
                                            </div>}
                                            {referrerCode && referrerName &&
                                                 <div className="col-lg-4">
                                                     <div className="form-group">
                                                         <label className="form-control-label">{props.t("referrer")}</label>
                                                         <div className="form-control-alternative form-control" style={{backgroundColor:"#e9ecef", display:"flex"}}>
                                                             <div title={referrerName} style={{whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}>{referrerName}</div>
                                                             {//这行本来就是注释的 {referrerCode && referrerCode.indexOf("C") != -1 ? null : <div style={{whiteSpace: "nowrap",}}>（{props.t("agentReferralCode")}：{referrerCode}）</div>} }
                                                         </div>
                                                     </div>
                                                 </div>
                                            }*/}
                                        </div>
                                    </div>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("referralPrize")}</label>
                                                    <select
                                                        className="form-control-alternative form-control"
                                                        name="referralPrize"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired")
                                                        })}>
                                                            <option value={0} selected={referralPrize===0}>{0}</option>
                                                            <option value={10} selected={referralPrize===10}>{10}</option>
                                                            <option value={15} selected={referralPrize===15}>{15}</option>
                                                            <option value={20} selected={referralPrize===20}>{20}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pl-lg-4">
                                        <div className="row">

                                        </div>
                                    </div>
                                    {/*referrerCode && referrerName && <div style={{marginLeft:"22px", padding:"10px 15px"}} className="ant-alert ant-alert-info ant-alert-with-description ant-alert-no-icon">
                                        {referrerCode && referrerCode.indexOf("C") < 0 ? props.t("descOther") : props.t("descCorp")}
                                    </div>*/}
                                    <input ref={submitRef} type="submit" hidden />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </form>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partnerId: state.session.partner ? state.session.partner.id : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveAgentAsync: (vo) => dispatch(Actions.saveAgentAsync(vo)),
        getPartnerByEmailAsync: (email) => dispatch(Actions.getPartnerByEmailAsync(email)),
        updateValues: val => dispatch(Actions.updateValues(val)),
        getAllCountryCodeAsync: () => dispatch(Actions.getAllCountryCodeAsync())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
